export default __webpack_public_path__ + "146d74add72c9940ee805eb16fdc5c64.png";